import Sidebar from "../components/Sidebar";
import SummaryCards from "../components/SummaryCards";
import TargetList from "../components/TargetList";
const Index = () => (
  <div className="flex min-h-screen w-full bg-background text-foreground">
    <Sidebar />
    <main className="flex-1 flex flex-col p-6 gap-4 max-w-full">
      <h1 className="text-2xl md:text-3xl font-bold tracking-tight">Dashboard</h1>
      <SummaryCards />
      <TargetList />
    </main>
  </div>
);

export default Index;